import React from "react";
import {
  Route,
  Routes,
  // Navigate
} from "react-router-dom";
import Home from "../pages/Home";

import Category from "../pages/category/Category";
import AddCategory from "../pages/category/AddCategory";

import Product from "../pages/product/Product";
import EditProduct from "../pages/product/EditProduct";
import AddProduct from "../pages/product/AddProduct";

import Order from "../pages/order/Order";

import Faq from "../pages/faq/Faq";
import AddFaq from "../pages/faq/AddFaq";

import Payments from "../pages/payment/Payment";
import AddPayment from "../pages/payment/AddPayment";

import Transaction from "../pages/transaction/Transaction";

import Supports from "../pages/support/Support";
import AddSupport from "../pages/support/AddSupport";

import PrivateRoute from "../routes/PrivateRoute";
import EditUser from "../pages/category/EditCategory";
import UserProfile from "../pages/profile/UserProfile";
import UserPassword from "../pages/updatePassword/UserPassword";

import Login from "../pages/loginPage/Login";
import Box from "@mui/material/Box";
import { styled } from "@mui/material";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

export default function PageRoutes() {
  return (
    <Box
      component='main'
      sx={{
        flexGrow: 1,
        px: 2.5,
        py: 7,
        minHeight: "100vh",
        overflow: "auto",
      }}
    >
      <DrawerHeader />
      <Routes>
        {/* this login page is temp. right now  */}
        <Route path='/login' element={<Login />} />

        <Route
          path='/'
          element={
            <PrivateRoute>
              <Home />
            </PrivateRoute>
          }
        />
        <Route
          path='/categories'
          element={
            <PrivateRoute>
              <Category />
            </PrivateRoute>
          }
        />
        <Route
          path='/addcategory'
          element={
            <PrivateRoute>
              <AddCategory />
            </PrivateRoute>
          }
        />
        <Route path='/edituser/:id' element={<EditUser />} />

        <Route
          path='/addfaq'
          element={
            <PrivateRoute>
              <AddFaq />
            </PrivateRoute>
          }
        />

        <Route
          path='/orders'
          element={
            <PrivateRoute>
              <Order />
            </PrivateRoute>
          }
        />

        <Route
          path='/products'
          element={
            <PrivateRoute>
              <Product />
            </PrivateRoute>
          }
        />
        <Route
          path='/editproduct/:id'
          element={
            <PrivateRoute>
              <EditProduct />
            </PrivateRoute>
          }
        />
        <Route
          path='/addproduct'
          element={
            <PrivateRoute>
              <AddProduct />
            </PrivateRoute>
          }
        />

        <Route
          path='/transactions'
          element={
            <PrivateRoute>
              <Transaction />
            </PrivateRoute>
          }
        />
        <Route
          path='/faq'
          element={
            <PrivateRoute>
              <Faq />
            </PrivateRoute>
          }
        />
        <Route
          path='/payments'
          element={
            <PrivateRoute>
              <Payments />
            </PrivateRoute>
          }
        />
        <Route
          path='/addpayments'
          element={
            <PrivateRoute>
              <AddPayment />
            </PrivateRoute>
          }
        />
        <Route
          path='/support'
          element={
            <PrivateRoute>
              <Supports />
            </PrivateRoute>
          }
        />
        <Route
          path='/addsupport'
          element={
            <PrivateRoute>
              <AddSupport />
            </PrivateRoute>
          }
        />
        <Route
          path='/profile'
          element={
            <PrivateRoute>
              <UserProfile />
            </PrivateRoute>
          }
        />
        <Route
          path='/account'
          element={
            <PrivateRoute>
              <UserPassword />
            </PrivateRoute>
          }
        />
        {/* <Route
                  path='*'
                  element={<Navigate to='/' replace></Navigate>}
                /> */}
      </Routes>
    </Box>
  );
}
